var map = {
	"../../components/about/about.module": [
		"./src/app/components/about/about.module.ts",
		"common"
	],
	"../../components/confidential-infos/confidential-infos.module": [
		"./src/app/components/confidential-infos/confidential-infos.module.ts",
		"common"
	],
	"../../components/contact-us/contact-us.module": [
		"./src/app/components/contact-us/contact-us.module.ts",
		"default~components-contact-us-contact-us-module~footer-page-footer-page-module",
		"common"
	],
	"../../components/game-limits/game-limits.module": [
		"./src/app/components/game-limits/game-limits.module.ts",
		"common"
	],
	"../../components/responsible-gaming/responsible-gaming.module": [
		"./src/app/components/responsible-gaming/responsible-gaming.module.ts",
		"common"
	],
	"../../components/terms-and-conditions/terms-and-conditions.module": [
		"./src/app/components/terms-and-conditions/terms-and-conditions.module.ts",
		"common"
	],
	"../balances/balances.module": [
		"./src/app/pages/balances/balances.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common"
	],
	"../bets/bets.module": [
		"./src/app/pages/bets/bets.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common",
		"bets-bets-module"
	],
	"../bonuses/bonuses.module": [
		"./src/app/pages/bonuses/bonuses.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common",
		"bonuses-bonuses-module"
	],
	"../how-to/how-to.module": [
		"./src/app/pages/how-to/how-to.module.ts",
		"default~footer-page-footer-page-module~how-to-how-to-module",
		"common"
	],
	"../personal-profile/personal-profile.module": [
		"./src/app/pages/personal-profile/personal-profile.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common"
	],
	"../promotions/promotions.module": [
		"./src/app/pages/promotions/promotions.module.ts",
		"promotions-promotions-module"
	],
	"../responsible-gambling/gambling-limits.module": [
		"./src/app/pages/responsible-gambling/gambling-limits.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~responsible-gambling-gambling-limits-module~user-actions-user-actions-module",
		"common",
		"responsible-gambling-gambling-limits-module"
	],
	"../transactions/transactions.module": [
		"./src/app/pages/transactions/transactions.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common"
	],
	"./footer-page/footer-page.module": [
		"./src/app/pages/footer-page/footer-page.module.ts",
		"default~footer-page-footer-page-module~miss-ci-miss-ci-module",
		"default~footer-page-footer-page-module~how-to-how-to-module",
		"default~components-contact-us-contact-us-module~footer-page-footer-page-module",
		"common",
		"footer-page-footer-page-module"
	],
	"./how-to/how-to.module": [
		"./src/app/pages/how-to/how-to.module.ts",
		"default~footer-page-footer-page-module~how-to-how-to-module",
		"common"
	],
	"./landing-page/landing-page.module": [
		"./src/app/pages/landing-page/landing-page.module.ts",
		"landing-page-landing-page-module"
	],
	"./miss-ci/miss-ci.module": [
		"./src/app/pages/miss-ci/miss-ci.module.ts",
		"default~footer-page-footer-page-module~miss-ci-miss-ci-module",
		"common",
		"miss-ci-miss-ci-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./profile-page/profile-page.module": [
		"./src/app/pages/profile-page/profile-page.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~c19b6225",
		"common",
		"profile-page-profile-page-module"
	],
	"./user-actions/user-actions.module": [
		"./src/app/pages/user-actions/user-actions.module.ts",
		"default~balances-balances-module~bets-bets-module~bonuses-bonuses-module~personal-profile-personal-p~93ae8048",
		"default~responsible-gambling-gambling-limits-module~user-actions-user-actions-module",
		"common",
		"user-actions-user-actions-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;